import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_s5_subjects from './uganda_s5_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_s5 = ( ) => {
 
  return (
    <>
   <TopNavbar />
   <Uganda />
<International_countries />
  <Uganda_s5_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_s5;
